import { Checkbox } from '@apollo/orbit';
import classnames from 'classnames';
import React, { useState } from 'react';

interface Props extends React.ComponentProps<typeof Checkbox> {
  value?: string;
  title: string;
  description?: React.ReactNode;
  canWriteCheckConfiguration?: boolean;
}

export const VariantCheckbox = ({
  value,
  isChecked,
  title,
  description,
  onFocus,
  onBlur,
  canWriteCheckConfiguration,
  isDisabled,
  ...other
}: Props) => {
  const [focused, setFocus] = useState(false);
  return (
    <label
      className={classnames(
        'flex flex-wrap items-center justify-between rounded border p-2',
        canWriteCheckConfiguration &&
          'cursor-pointer hover:border-hover hover:bg-btn-secondary-hover hover:shadow-md',
        isChecked && canWriteCheckConfiguration && !isDisabled
          ? 'border-info'
          : 'border-primary',
        focused && 'shadow',
        isDisabled &&
          'border-disabled bg-disabled hover:cursor-not-allowed hover:border-disabled hover:bg-disabled hover:shadow-none',
      )}
    >
      <div className="flex items-center">
        <Checkbox
          className={classnames('h-fit cursor-pointer', {
            'cursor-not-allowed': isDisabled,
          })}
          isChecked={isChecked}
          value={value}
          isDisabled={!canWriteCheckConfiguration || isDisabled}
          onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
            setFocus(true);
            if (onFocus) {
              onFocus(e);
            }
          }}
          onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
            setFocus(false);
            if (onBlur) {
              onBlur(e);
            }
          }}
          {...other}
        />
        <span className="ml-2 break-all">{title}</span>
      </div>
      <div className="ml-5 text-secondary">{description}</div>
    </label>
  );
};
